export const VehicleMarketSlug = 'fahrzeugbestand';
export const FavoritesSlug = 'favoriten';

export function getVehicleMarketUrl(dealerSlug?: string): string {
    return `/${dealerSlug ? `${dealerSlug}/` : ''}${VehicleMarketSlug}`;
}

export function getVehicleMarketDetailUrl(slug: string, dealerSlug?: string): string {
    return `${getVehicleMarketUrl(dealerSlug)}/${slug}`;
}

export function getFavoritesUrl(dealerSlug?: string): string {
    return `/${dealerSlug ? `${dealerSlug}/` : ''}${FavoritesSlug}`;
}
